import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=3be4e3c2&scoped=true&"
import script from "./scene.vue?vue&type=script&lang=ts&"
export * from "./scene.vue?vue&type=script&lang=ts&"
import style0 from "./scene.vue?vue&type=style&index=0&id=3be4e3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be4e3c2",
  null
  
)

export default component.exports